import axios from 'axios';

const SchoolTerms = [];
const Levels = [];
// const MasteryCompetency = [];
// const MasteryGradeLevels = [];
// const MasterySubjects = [];
// const MasteryTerms = [];
const AccountTypes = [];

// const url = `${process.env.REACT_APP_API_LOOKUP}/list`;
const getTerms = () => {
   axios.get(`${process.env.REACT_APP_API_LOOKUP}/termlist`).then((response) => {
      if (response.data) {
         const data = response.data;
         data.map((item) => {
            let obj = { 'value': item.value, 'name': item.name }
            SchoolTerms.push(obj);
         });
      }
   }, (error) => {
      console.log(error.message);
   });
}

const getLevels = () => {
   axios.get(`${process.env.REACT_APP_API_LOOKUP}/levellist`).then((response) => {
      if (response.data) {
         const data = response.data;
         data.map((item) => {
            let obj = { 'value': item.value, 'name': item.name }
            Levels.push(obj);
         });
      }
   }, (error) => {
      console.log(error.message);
   });
}

const getAccountTypes = () => {
   const obj = [
      { 'value': -10, 'name': 'Super Admin' },
      { 'value': -1, 'name': 'Admin' },
      { 'value': 0, 'name': 'Teacher' },
      { 'value': -5, 'name': 'Co-Teacher' },
      { 'value': -2, 'name': 'Registrar' },
      { 'value': -3, 'name': 'Guidance' },
      { 'value': -4, 'name': 'Cashier' },
   ]

   AccountTypes.push(...obj);
}

getTerms();
getLevels();
getAccountTypes();

export {
   SchoolTerms,
   Levels,
   AccountTypes
}

export const allowed_levels_in_microcredentials = ['11', '12'];
